// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {putDuplicatePinPlateRequest, putFactoyDuplicatePinPlateRequest} from '../../../product/shared/repositories';
import {routerActions} from 'react-router-redux';
import {
    successAlertBar
} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const handleDuplicatePinPlateUpdate = duplicatePinPlate =>
    async dispatch => {

        let route;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await putDuplicatePinPlateRequest(duplicatePinPlate);
            route = '/products/factory-shipping-info';
            successAlertBar(translate('DUPLICATE_PIN_PLATE_REQUEST_UPDATED'));
            dispatch(routerActions.push(route));

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const handleDuplicatePinPlateInProcess = duplicatePinPlate =>
        async dispatch => {

            let route;

            const updatedDuplicatePinPlate = {
                ...duplicatePinPlate,
                status: 'INPROCESS'
            };

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await putFactoyDuplicatePinPlateRequest(updatedDuplicatePinPlate);
                route = '/products/factory-shipping-info';
                successAlertBar(translate('DUPLICATE_PIN_PLATE_REQUEST_UPDATED'));
                dispatch(routerActions.push(route));

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        };



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/action-creators/handle-update.js